import { TEXT_SDQ_REPORT } from 'constants/string/texts';

/**
 * "お子さんの得意は PB, PP です。" - the subscale keys are listed raw, as in the app.
 * `variant` switches the prefix for the BR07 layout.
 */
const SdqStrengthIntroLine = (props) => {
  const { subscaleKeys, className = 'text-sm font-bold', variant = 'mixed' } = props;
  const prefix = variant === 'br07' ? TEXT_SDQ_REPORT.STRENGTHS_BR07_INTRO_PREFIX : TEXT_SDQ_REPORT.STRENGTHS_INTRO_PREFIX;

  return (
    <p className={className}>
      {prefix}
      {subscaleKeys.join(', ')}
      {TEXT_SDQ_REPORT.STRENGTHS_INTRO_SUFFIX}
    </p>
  );
};

export default SdqStrengthIntroLine;
